import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Ddata from '../data/Ddata';
function Populardest() {
  return (
    <div>
        
    <div className='container-fluid  py-5'>
    <h1 className='text-start px-3 pt-5 pb-5 fw-normal'>Popular Destinations</h1>
  <div className="row px-3">
    <div className="col-lg-12">
    <OwlCarousel className='owl-theme' loop margin={10} items={4}nav>
        {Ddata.map((a)=>(
          <div className='card'>
          <img className='w-100 position-relative' src={a.image}/>
          <div className='country'>
          <h4 className='text-center'>{a.title}</h4>
          </div>
       </div>
        ))}
        </OwlCarousel>
      </div>
    </div>
    </div>
    </div>
  )
}

export default Populardest
